import React from 'react';
import useIsFCM from '../hooks/useIsFCM';
import useIsCBD from '../hooks/useIsCBD';
import HomeCMP from './HomeCMP';
import HomeEMP from '../containers/Home';

const AppHome: React.FC = () => {
  const isFCM = useIsFCM();
  const isCBD = useIsCBD();
  // If null then the EnvPromise has not resolved yet and we cant
  // know for sure if the user is an FCM or CBD or not.
  if (isFCM === null || isCBD === null) return null;
  return (isFCM || isCBD) ? <HomeCMP /> : <HomeEMP />;
};

export default AppHome;
